/**
 * TanStack Query hooks for `dpa`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dpaQueryKeys,
	type CreateDpaBody,
	type ListDpaResponse,
	type DpaRow,
} from "./api";

export function useDpaList(): UseQueryResult<ListDpaResponse, Error> {
	return useQuery({
		queryKey: dpaQueryKeys.list(),
		queryFn: list,
	});
}

export function useDpaCreate(): UseMutationResult<DpaRow, Error, CreateDpaBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpaQueryKeys.all });
		},
	});
}

export function useDpaDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dpaQueryKeys.all });
		},
	});
}
